var genId = function (id) { return Date.now().toString(24) + id.toString(); };
export default genId;
